import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";

const InsectDiseasePestForm = (props) => {
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const { sendRequest: postInsectdiseasepest } = useHttp();


  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      insectDiseasePestType: type,
      insectDiseasePestName: name,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId, 
    };

    //console.log("data",data);

    if (props.update) {
      data["insectDiseasePestId"] = props.update.insectDiseasePestId;
    }

    postInsectdiseasepest(
      {
        url: "/api/insectdiseasepest/",
        method: props.update ? "PUT" : "POST",

        body: data,
      },
      (res) => {
        toast.success(`Insect/Disease/Pest Details ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    //console.log(props.update);
    if (props.update) {
      setType(props.update.insectDiseasePestType);

      setName(props.update.insectDiseasePestName);

   
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Insect/Disease/Pest Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Insect/Disease/Pest Type</label>
                        <input
                          type={"text"}
                          id={"type"}
                          required
                          className="form-control"
                          value={type}
                          onChange={(e) => {
                            setType(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                   
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Insect/Disease/Pest Name</label>
                        <input
                          type={"text"}
                          id={"seasonName"}
                          required
                          className="form-control"
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default InsectDiseasePestForm